module.exports = __webpack_public_path__ + "img/img2.423bd1f0.png";